import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import {
  CustomCard,
  PageHeading,
  HeaderColumn,
  BootstrapTable,
  LastHeaderColumn,
  FirstHeaderColumn
} from "../common-styling";
import Filter from "../table-filter/filter";
import TableLoader from "../loader/table-loader";
import CustomersTableRow from "./customer-table-row";
import { showError } from "../../services/toast-service";
import CustomPagination from "../pagination/custom-pagination";
import { getAllCustomers } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";
import { CUSTOMER_TYPE } from "../strings";
import { Tab, Tabs } from "react-bootstrap";

const CustomersTable = () => {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginateOpts, setPaginateOpt] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const { COCKPIT, HUBSPOT } = CUSTOMER_TYPE;
  const isHubspotTabSelected = searchParams.get("view") === HUBSPOT;

  const fetchCustomersData = async () => {
    try {
      setIsLoading(true);
      const params = {
        isHubspotCustomer: isHubspotTabSelected ? true : undefined
      };
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      let response = await getAllCustomers(params);
      const data = response.data.data;
      setCustomers(data.rows);
      setPaginateOpt({
        totalPages: data.totalPages,
        hasPrevPage: data.hasPrevPage,
        hasNextPage: data.hasNextPage,
        totalDocs: data.totalDocs,
        rowsOnPage: data.rows.length
      });
    } catch (error) {
      console.log(error);
      showError(
        error.response.data.message ||
          t("toastMessage.errorInGetting", {
            what: t("common.customer", { count: 2 })
          })
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleQueryParams = (property, value) => {
    searchParams.set(property, value);
    setSearchParams(searchParams);
  };

  const handleSelectTab = (evKey) => {
    searchParams.set("view", evKey);
    setSearchParams(searchParams);
  };

  const customersCb = useCallback(
    fetchCustomersData,
    // eslint-disable-next-line
    [searchParams]
  );

  useEffect(() => {
    customersCb();
  }, [customersCb]);
  const navigate = useNavigate();
  const handleModal = () => {
    navigate("new");
  };
  return (
    <div>
      <PageHeading className="">{t("sidebar.customers")}</PageHeading>
      <div className="mt-3">
        <Filter
          pageName="name"
          placeholder={t("searchByNamePlaceholder")}
          btnText={t("common.createNew.title", {
            name: t("common.customer").toLowerCase()
          })}
          handleModal={handleModal}
          shouldDisplayResourceType={false}
        />
      </div>
      <Tabs
        id="justify-tabs"
        className="mt-4 mb-2"
        onSelect={(evKey) => handleSelectTab(evKey)}
        activeKey={isHubspotTabSelected ? HUBSPOT : COCKPIT}
      >
        <Tab
          eventKey={COCKPIT}
          title={t("customerTabs.cockpitCustomers")}
        ></Tab>
        <Tab
          eventKey={HUBSPOT}
          title={t("customerTabs.hubSpotCustomers")}
        ></Tab>
      </Tabs>
      <CustomCard className="mt-4 mb-3 p-3 rounded-0">
        <BootstrapTable responsive>
          <thead>
            <tr>
              <FirstHeaderColumn>{t("customerName")}</FirstHeaderColumn>
              <HeaderColumn>{t("common.email")}</HeaderColumn>
              <HeaderColumn>{t("common.companyName")}</HeaderColumn>
              <HeaderColumn>{t("common.telephone")}</HeaderColumn>
              <LastHeaderColumn></LastHeaderColumn>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableLoader colSpan={5} />
            ) : (
              <CustomersTableRow
                customers={customers}
                fetchCustomersData={fetchCustomersData}
                isHubspotTabSelected={isHubspotTabSelected}
              />
            )}
          </tbody>
        </BootstrapTable>
      </CustomCard>
      <CustomPagination
        paginateOpts={paginateOpts}
        activeTab={Number(searchParams.get("pageIndex")) || 1}
        select={(val) => handleQueryParams("pageIndex", val)}
      />
    </div>
  );
};
export default CustomersTable;
